import React from 'react'
import Fragment from '../common/fragment'


function FragmentCW(props) {
  return (
    <Fragment pos="www" {...props}>
      <p>
Un día el cielo se cubrió de negro en Salamanca y la gente se ocultó en sus casas
temiendo al aire que los perseguía. En agosto de 1915 empezó la guerra química,
cuando las tropas alemanas abrieron miles de frascos y esparcieron una sustancia
verde que llegó con el viento hasta las tropas francesas, apostadas en sus trincheras.
Ese día nacieron las atmósferas, cuando esos soldados no pudieron respirar. El
verde de los químicos se parecía al verde de los prados. El cielo de Salamanca se
oscureció y la ciudad descubrió las turbias atmóferas del plástico. Un ejambre de
líquidos y partículas, nacido de una colmena aciaga. Los pulmones como abismos.
Las narices tapadas. La boca seca. Síntomas de que estamos vivos, pero en peligro.
      </p>
    </Fragment>
  )
}


export default FragmentCW
